import gql from "graphql-tag";

export const PORTAL_ORDERS_QUERY = gql`
  query portalOrders(
    $operatorId: String!
    $skip: Int
    $first: Int
    $startDate: String
    $endDate: String
    $startCaptureDate: String
    $endCaptureDate: String
    $protocol: String
    $licensePlate: String
    $renavam: String
    $externalOrderNumber: String
    $establishment: String
    $state: String
    $status: String
    $startUpdateDate: String
    $endUpdateDate: String
  ) {
    portalOrders(
      operatorId: $operatorId
      skip: $skip
      first: $first
      startDate: $startDate
      endDate: $endDate
      startCaptureDate: $startCaptureDate
      endCaptureDate: $endCaptureDate
      protocol: $protocol
      licensePlate: $licensePlate
      renavam: $renavam
      externalOrderNumber: $externalOrderNumber
      establishment: $establishment
      state: $state
      status: $status
      startUpdateDate: $startUpdateDate
      endUpdateDate: $endUpdateDate
    ) {
      count
      consolidated {
        base
        total
        totalDebit
        totalCredit
        count
      }
      cancelled {
        base
        total
        totalDebit
        totalCredit
        count
      }
      simulations {
        total
        count
      }
      orders {
        id
        createdAt
        updatedAt
        baseAmount
        licensePlate
        renavam
        order {
          id
          protocol
          externalOrderNumber
          totalAmount
          baseAmount
          orderStatus
        }
        establishment {
          title
        }
      }
    }
  }
`;

export const PORTAL_ESTABLISHMENTS_QUERY = gql`
  query PortalEstablishments($operatorId: String!) {
    portalEstablishments(operatorId: $operatorId) {
      id
      title
      address {
        state
      }
    }
  }
`;

export const PORTAL_ESTABLISHMENTS_STATES_QUERY = gql`
  query PortalEstablishmentsStates($operatorId: String!) {
    portalEstablishmentsStates(operatorId: $operatorId) {
      states
    }
  }
`;

export const PORTAL_STATUS_QUERY = gql`
  query portalOrders($operatorId: String!) {
    portalOrders(operatorId: $operatorId) {
      statusList
    }
  }
`;

export const PORTAL_REFRESH_TOKEN = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token) {
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/graphql.js